<template>
	<n-modal
		v-model:show="show"
		preset="dialog"
		type="warning"
		title="Qualité d'image faible"
		:closable="false"
		:maskClosable="false">
		<template #header>
			<div class="text-warning">
				Qualité d'image faible
			</div>
		</template>
		La qualité de l'image semble faible, ce qui pourrait affecter la précision de la reconnaissance.
		<template #action>
			<n-button
				@click="onContinue">
				Ignorer et lancer l'analyse
			</n-button>
			<n-button
				type="primary"
				@click="onScanAgain">
				Scanner à nouveau
			</n-button>
		</template>
	</n-modal>
</template>

<script>
import {ref} from 'vue'
import {NModal, NButton} from 'naive-ui'

export default {
	name: 'LowConfidenceDialog',
	components: {
		NModal,
		NButton
	},
	emits: ['scan-again', 'continue'],
	setup(props, {emit}) {
		const show = ref(false)

		const open = () => {
			show.value = true
		}

		const onScanAgain = () => {
			show.value = false
			emit('scan-again')
		}

		const onContinue = () => {
			show.value = false
			emit('continue')
		}

		return {
			show,
			open,
			onScanAgain,
			onContinue
		}
	}
}
</script>
